export default __webpack_public_path__ + "static/media/thecelestialnecropolis.3534d9f2.jpg";